import { currencySymbols } from '../../config/currency-symbols';
import { IUpSellGenerateViewModel, IUpSellRenderModel } from '../../config/upsell-response';
import { View } from '../view';

export class UpSellDonationView extends View {

    container = this.getDFContainer();

    amounts: {
        prodName: string;
        amounts: { amount: number, default: boolean }[]
    }[] = [];

    defaultAmount = 0;
    defaultFrequency = '';

    get defAmount() {
        return this.defaultAmount;
    }

    donationRender(model: IUpSellRenderModel) {
        this.amounts = [];
        const fields = document.createElement('div');
        fields.classList.add('single-donation-container', 'hs-form', 'stacked', 'df-f', 'df-f-donation');

        model.products.forEach(prod => {
            if (prod.amounts) {
                this.amounts.push({ prodName: this.formProductName(prod.name), amounts: prod.amounts });
            }
            fields.appendChild(this.generateProductTemplate({ product: prod, currency: model.currency, callback: model.callback, isOneProduct: model.isOneProduct }));
        });

        this.container.appendChild(fields);
    }

    generateProductTemplate(viewModel: IUpSellGenerateViewModel): HTMLElement {
        const elem = document.createElement('div');
        const prodAmounts = this.amounts.find(x => x.prodName === this.formProductName(viewModel.product.name));
        const amountButtons: HTMLInputElement[] = [];

        const donationInputContainer = document.createElement('div');
        donationInputContainer.classList.add('input-group');

        const donationInputCurrency = document.createElement('div');
        donationInputCurrency.classList.add('input-group-icon');
        donationInputCurrency.innerHTML = currencySymbols[viewModel.currency];

        const donationInputArea = document.createElement('div');
        donationInputArea.classList.add('input-group-area');

        donationInputContainer.appendChild(donationInputCurrency);
        donationInputContainer.appendChild(donationInputArea);

        const donationInput = document.createElement('input') as HTMLInputElement;
        donationInput.type = 'number';
        donationInput.classList.add('df-upsell-donation-input', 'hs-input', 'amount', 'df-input');
        donationInput.setAttribute('min', viewModel.product.minimumDonation ? viewModel.product.minimumDonation.toString() : '0');
        donationInput.setAttribute('name', this.formProductName(viewModel.product.name));
        donationInput.setAttribute('value', viewModel.product.minimumDonation ? viewModel.product.minimumDonation.toString() : '0');
        donationInput.setAttribute('payment-type', viewModel.product.type);
        donationInput.setAttribute('id', viewModel.product.id || 'NoIdProvided');

        donationInput.onchange = (ev) => {
            this.defaultAmount = Number((ev.target as HTMLInputElement).value);
            amountButtons.forEach(x => x.classList.remove('active'));

            viewModel.callback(viewModel.product, this.defaultAmount, this.defaultFrequency);
        };

        this.defaultFrequency = viewModel.product.defaultFrequency || 'one_time';
        if (viewModel.product.frequency) {
            const freqButtons: HTMLElement[] = [];
            const freqFieldSet = document.createElement('fieldset');
            freqFieldSet.classList.add('form-columns-2', 'df-fieldset');

            viewModel.product.frequency.forEach(freq => {
                const freqContainer = document.createElement('div');
                freqContainer.classList.add('field', 'hs-form-field', 'donation-interval-btn-container', 'df-field', 'df-upsell-interval');

                const freqInput = document.createElement('input') as HTMLInputElement;

                freqInput.type = 'button';
                freqInput.classList.add('df-upsell-donation-frequency-input', 'hs-input', 'donation-interval-btn', 'cursor-pointer', 'df-input');
                freqInput.setAttribute('id', `${this.formProductName(viewModel.product.name)}-${freq}-frequency`);
                freqInput.setAttribute('name', `${this.formProductName(viewModel.product.name)}-frequency`);
                freqInput.innerHTML = this.formatFrequency(freq);
                freqInput.value = this.formatFrequency(freq);
                freqInput.checked = this.defaultFrequency === freq;

                if (this.defaultFrequency === freq) {
                    freqInput.classList.add('active');
                }

                freqInput.addEventListener('click', (ev) => {
                    this.defaultFrequency = freq;
                    freqButtons.forEach(x => x.classList.remove('active'));
                    freqInput.classList.add('active');
                    viewModel.callback(viewModel.product, this.defaultAmount, this.defaultFrequency);
                });

                freqButtons.push(freqInput);
                freqContainer.appendChild(freqInput);
                freqFieldSet.appendChild(freqContainer);
            });
            elem.appendChild(freqFieldSet);
        }

        if (prodAmounts) {
            const amountFieldSet = document.createElement('fieldset');
            amountFieldSet.classList.add('gift-amounts', 'form-columns-3');

            prodAmounts.amounts.forEach(am => {
                const amountInputContainer = document.createElement('div');
                amountInputContainer.classList.add('field', 'hs-form-field', 'donation-gift-amount-btn-container', 'df-field', 'df-upsell-amount');

                const donationAmountBtn = document.createElement('input');

                if (am.default) {
                    this.defaultAmount = am.amount;
                    donationInput.setAttribute('value', am.amount.toString());
                    donationInput.value = am.amount.toString();
                    donationAmountBtn.classList.add('active');
                }

                donationAmountBtn.setAttribute('type', 'button');
                donationAmountBtn.classList.add('hs-input', 'gift-amount-btn', 'cursor-pointer', 'df-input');
                donationAmountBtn.value = this.formatMoney(am.amount.toString(), viewModel.currency);
                donationAmountBtn.innerHTML = this.formatMoney(am.amount.toString(), viewModel.currency);

                donationAmountBtn.addEventListener('click', (ev) => {
                    this.defaultAmount = am.amount;
                    donationInput.setAttribute('value', this.defaultAmount.toString());
                    donationInput.value = this.defaultAmount.toString();

                    amountButtons.forEach(x => x.classList.remove('active'));
                    donationAmountBtn.classList.add('active');

                    viewModel.callback(viewModel.product, this.defaultAmount, this.defaultFrequency);
                });
                amountButtons.push(donationAmountBtn);
                amountInputContainer.appendChild(donationAmountBtn);
                amountFieldSet.appendChild(amountInputContainer);
            });

            elem.appendChild(amountFieldSet);
        }

        donationInputArea.appendChild(donationInput);
        elem.appendChild(donationInputContainer);

        viewModel.callback(viewModel.product, this.defaultAmount, this.defaultFrequency);
        return elem;
    }

    formProductName(prodName: string) {
        return prodName.split(' ').join('');
    }

    formatFrequency(freq: string) {
        switch (freq) {
            case 'one_time':
                return 'One time';
            case 'monthly':
                return 'Monthly';
            default:
                return freq;
        }
    }

}
